module.exports = __webpack_public_path__ + "img/aerospace.729007f9.svg";